import React, { useRef, useState } from 'react'
import { colors } from 'config/ui'
import { Modal } from 'components/lib/modals'
import copyToClipboard from 'utils/copyToClipboard'
import {
  Description,
  ModalFirstAccessSkin,
  Title,
  DetailsBox,
  Text,
  Code,
  Canvas,
  LinkToContinue
} from './ModalPositivoFirstAccess.styles'
import { Button } from 'components/lib/buttons'
import { FontIcon } from 'components/lib/icons'
import { useTranslation } from 'i18n'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import { Cdn } from 'utils/assets'

const ModalFirstAccess = ({ show, onClose, accessToken }) => {
  const { user } = useUserInfo()
  const { t } = useTranslation()
  const image = useRef()
  const [copyToClipboardLabel, setCopyToClipboardLabel] = useState(
    t('Copiar código')
  )
  const saveWallet = () => {
    const myCanvas = document.querySelector('#myCanvas')

    const ctx = myCanvas.getContext('2d')

    ctx.clearRect(0, 0, myCanvas.width, myCanvas.height)
    ctx.drawImage(image.current, 0, 0)

    ctx.font = 'bold 60px Averta'
    ctx.textAlign = 'center'
    ctx.fillText(accessToken, myCanvas.width / 2, 320)

    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(myCanvas.msToBlob(), 'carteirinha-arvore.png')
    } else {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.href = myCanvas.toDataURL()
      a.download = 'carteirinha-arvore.png'
      a.click()

      document.body.removeChild(a)
    }
  }
  const copyToClipboardHandler = () => {
    copyToClipboard(user.accessToken)
    setCopyToClipboardLabel(t('Copiado!'))
    setTimeout(() => setCopyToClipboardLabel(t('Copiar código')), 3000)
  }
  return (
    <Modal
      title=""
      show={show}
      onClose={() => {
        onClose()
      }}
    >
      <img
        src={Cdn.getImageUrl('wallet.jpg')}
        ref={image}
        alt=""
        style={{ display: 'none' }}
        crossOrigin={'anonymous'}
      />
      <Canvas id="myCanvas" width="360" height="700" />
      <ModalFirstAccessSkin>
        <Title>{t('Baixe nosso aplicativo!')}</Title>
        <Description>
          {t(
            'Você também pode acessar pelo aplicativo da Árvore Livros, utilizando o código abaixo. Ele substitui email e senha na hora do login. Guarde seu código com carinho!'
          )}
        </Description>
        <DetailsBox>
          <Text>{t('Anote o seu código de acesso:')}</Text>
          <Code>{accessToken}</Code>
          <Button
            color={colors.black2}
            newSize={'large'}
            textColor={colors.black4}
            textColorHover={colors.black5}
            noTextTransform={true}
            outline
            style={{ marginBottom: '32px' }}
            onClick={copyToClipboardHandler}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <path
                fill="#86878B"
                fillRule="evenodd"
                d="M17.5 6.667c1.38 0 2.5 1.12 2.5 2.5V17.5c0 1.38-1.12 2.5-2.5 2.5H9.167c-1.38 0-2.5-1.12-2.5-2.5V9.167c0-1.38 1.12-2.5 2.5-2.5H17.5zm0 1.666H9.167c-.46 0-.833.374-.833.834V17.5c0 .46.373.833.833.833H17.5c.46 0 .834-.373.834-.833V9.167c0-.46-.374-.834-.834-.834zM10.834 0c1.38 0 2.5 1.12 2.5 2.5v1.667c0 .46-.374.833-.834.833-.46 0-.833-.373-.833-.833V2.5c0-.46-.374-.833-.833-.833H2.5c-.46 0-.833.373-.833.833v8.333c0 .46.373.834.833.834h1.667c.46 0 .833.373.833.833 0 .46-.373.833-.833.833H2.5c-1.38 0-2.5-1.12-2.5-2.5V2.5C0 1.12 1.12 0 2.5 0z"
              />
            </svg>
            {copyToClipboardLabel}
          </Button>
          <Button
            newSize={'large'}
            noTextTransform={true}
            color={colors.wisteria}
            textColor={colors.white}
            justifyContent="center"
            style={{ width: '100%' }}
            sharpBorders={true}
            onClick={() => saveWallet()}
          >
            <FontIcon
              color={colors.white}
              iconName="arrow_downward"
              size={20}
              style={{ marginRight: '4px' }}
            />{' '}
            {t('Salvar carteirinha')}
          </Button>
        </DetailsBox>
        <LinkToContinue onClick={() => onClose()}>
          {t('Continuar')}
        </LinkToContinue>
      </ModalFirstAccessSkin>
    </Modal>
  )
}

export default ModalFirstAccess
